import React from 'react';

import { useSearchParams } from 'react-router-dom';

import NavigationBar from 'components-new/navigation-bar/navigation-bar';

import getNewNavigationBarLinks, {
  getAccountMenuItems,
  getAccountMenuViews,
} from 'utils/get-new-navigation-bar-links';

import useGetOrganisationPeriodJobs from 'state/remote/remote-organization/use-get-organisation-period-jobs';

import { useOrganisationContext } from 'state/context/OrganisationContext';

import Divider from 'components-new/divider/divider';

import PeriodJobList from './components/PeriodJobsList';

import Header from './components/Header';

import PeriodJobDetails from './components/PeriodJobDetailsView';
import ConfirmationSection from './components/ConfirmationSection';
import AssignmentDetailsView from './components/assignment-details/AssignmentDetailsView';
import useGetView from './components/use-get-view';

const OrganisationPeriodJobsPage: React.FC = () => {
  const { data, isLoading: periodJobsLoading } = useGetOrganisationPeriodJobs();
  const {
    user: { data: userData },
  } = useOrganisationContext();

  const accountMenuViews = getAccountMenuViews(
    userData?.is_freelancer || false,
    userData?.is_organisation_admin || false,
    userData?.is_staff || false,
    'organisation',
  );

  const accountMenuItems = getAccountMenuItems(
    userData?.is_freelancer || false,
  );

  const links = getNewNavigationBarLinks('assignments');

  const searchParams = useSearchParams()[0];

  const { showAssignmentDetails, showJobConfirm, showJobDetails, showList } =
    useGetView();

  return (
    <div className="w-full flex flex-col items-center justify-start">
      <NavigationBar
        className="col-span-2 w-full"
        user={userData}
        links={links}
        accountMenuItems={accountMenuItems}
        accountMenuViews={accountMenuViews}
      />
      <Header periodJobs={data} />

      <div className="w-full md:w-[90%] lg:w-[80%] px-6 md:px-10 flex flex-col items-center justify-center align-middle">
        <Divider orientation="horizontal" className="w-full mt-3 mb-4" />
        {showList && !periodJobsLoading && <PeriodJobList jobs={data} />}
        {showJobDetails && (
          <PeriodJobDetails
            jobId={parseInt(searchParams.get('job_id') || '', 10)}
          />
        )}
        {showJobConfirm && <ConfirmationSection />}
        {showAssignmentDetails && (
          <AssignmentDetailsView jobId={searchParams.get('job_id') || ''} />
        )}
      </div>
    </div>
  );
};

export default OrganisationPeriodJobsPage;
